export const cols = [{
	prop: 'ordernumber,orderid',
	label: '订单编号',
	width: '260',
	ischoose: true,
	disabled: true,
	sortable: false,
	align: 'center'
}, {
	prop: 'createdate',
	label: '下单时间',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'orderstatus',
	label: '订单状态',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'shopname',
	label: '店铺名称',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'pcode',
	label: '商品编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'bigcategoryname',
	label: '店铺级大类',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'smallcategoryname',
	label: '店铺级小类',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'speccode',
	label: '规格编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'matchcode',
	label: '第三方编号',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'punit',
	label: '基础单位',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'assistunit',
	label: '辅助单位',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'giftflag',
	label: '是否赠品',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'weight',
	label: '重量',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'packing',
	label: '包装清单',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'initialprice',
	label: '单价',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'price',
	label: '实际单价',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'livequantity',
	label: '订单商品数量',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'livemoney',
	label: '订单商品金额',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'totaldiscountmoney',
	label: '优惠',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货数量',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'realmoney',
	label: '订货金额',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'sendcount',
	label: '发货数量',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'sendmoney',
	label: '发货金额',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'getcount',
	label: '收货数量',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'getmoney',
	label: '收货金额',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customercode',
	label: '客户编号',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '180',
	ischoose: true,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'detailmemo',
	label: '单品备注',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buyername',
	label: '收货人',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buytel',
	label: '联系电话',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '180',
	ischoose: false,
	disabled: false,
	sortable: false,
	align: 'center'
}]
